import { render, staticRenderFns } from "./ShareExpiryTime.vue?vue&type=template&id=46cd2ca2&scoped=true"
import script from "./ShareExpiryTime.vue?vue&type=script&lang=js"
export * from "./ShareExpiryTime.vue?vue&type=script&lang=js"
import style0 from "./ShareExpiryTime.vue?vue&type=style&index=0&id=46cd2ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd2ca2",
  null
  
)

export default component.exports